import CheckGreen from "check-green.svg";
import cn from "classnames";
import Eye from "eye.svg";
import EyeClosed from "eye-closed.svg";
import { generatePassword } from "helpers/system";
import Tooltip from "rc-tooltip";
import React from "react";
import PhoneInput from "react-phone-input-2";

export function validatePhoneNumber(phoneNumber: string) {
    const regex = /^\+[0-9]{11}$/;
    return regex.test(phoneNumber);
}

const passwordRequirementsTooltip = (
    <div>
        Пароль должен содержать 8 символов: латинские буквы и цифры.
    </div>
);

export function Step2UserInfo({ state, setState, showPassword, toggleShowPassword }: any) {
    const handleGeneratePassword = () => {
        setState({ ...state, password: generatePassword() });

        if (!showPassword) {
            toggleShowPassword();
        }
    };

    return (
        <>
            <div
                className={cn("r-form__group", {
                    "r-form__group--full": validatePhoneNumber(state.phoneNumber),
                })}
            >
                <div>
                    <label htmlFor="phoneNumber" className="r-form__label">
                        Телефон{" "}
                        <Tooltip
                            overlay="Нужен для восстановления доступа и связи с поддержкой. Без рекламных звонков"
                            placement="top"
                        >
                            <i className="icon-uEA69-question-circle" />
                        </Tooltip>
                    </label>
                    <PhoneInput
                        country="ru"
                        onlyCountries={["ru", "kz"]}
                        localization={{ ru: "Россия", kz: "Казахстан" }}
                        placeholder="+7 ___ ___-__-__"
                        onChange={(value: string) => setState({ ...state, phoneNumber: `+${value}` })}
                        dropdownStyle={{
                            width: "220px",
                            maxHeight: "110px",
                            margin: "5px 0",
                        }}
                        value={state.phoneNumber}
                        inputProps={{
                            required: true,
                            autoComplete: "off",
                            name: "phoneNumber",
                            className: "r-form__input",
                            id: "phoneNumber",
                        }}
                    />
                </div>
                <div className="r-form__after-icon">{validatePhoneNumber(state.phoneNumber) && <CheckGreen />}</div>
            </div>
            <div
                className={cn("r-form__group r-form__group--with-password-generator", {
                    "r-form__group--full": state.password.length > 0,
                })}
            >
                <div className="position-relative">
                    <label htmlFor="password" className="r-form__label">
                        Пароль{" "}
                        <Tooltip overlay={passwordRequirementsTooltip} placement="top">
                            <i className="icon-uEA69-question-circle" />
                        </Tooltip>
                    </label>
                    <input
                        required
                        className="r-form__input"
                        autoComplete="off"
                        type={showPassword ? "text" : "password"}
                        value={state.password}
                        id="password"
                        name="password"
                        onChange={(e) => setState({ ...state, password: e.target.value })}
                        placeholder="Придумайте пароль"
                    />
                    <button
                        type="button"
                        className="r-form__input-inline-btn"
                        aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
                        onClick={toggleShowPassword}
                    >
                        {showPassword ? <EyeClosed /> : <Eye />}
                    </button>
                    <button
                        type="button"
                        className="btn btn-link d-block p-0 mt-1 font-size-12 text-left"
                        onClick={handleGeneratePassword}
                    >
                        Сгенерировать надёжный пароль
                    </button>
                </div>
                <div className="r-form__after-icon">{state.password.length > 0 && <CheckGreen />}</div>
            </div>
        </>
    );
}
